import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import reducer from './reducer';
// import apiMiddleWare from './middlewares/api';
import sagas from './sagas/';

const sagaMiddleware = createSagaMiddleware()

export default configureStore({
    reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(sagaMiddleware)
        // If you need apiMiddleware, add: .concat(apiMiddleWare, sagaMiddleware)
});

sagaMiddleware.run(sagas);